import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubbleWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBubbleWide"><Path d="M22 3H2V19H8.74274L11.9951 21.7263L15.2858 19H22V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubbleWide;
